/*
 *  Copyright (c) Qwoach LLC 2022. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 27/1/2022
 */



import BaseObject from "@shared/BaseObject";

export default class AddressItem extends BaseObject {

	street: string = null
	aptSuit: string = null
	additionalAddress: string = null
	city: string = null
	zip: string = null
	country: string = null
	state: string = null

	isEmpty(){
		return !(this.street || this.state || this.aptSuit || this.additionalAddress || this.city || this.zip || this.country || this.state)
	}

	short(){
		return [
			this.city,
			this.state,
			this.country,
		].filter(item => !!item).join(", ")
	}

	formatted(){
		return this.toString()
	}

	toString(){
		return [
			this.street,
			this.aptSuit,
			this.additionalAddress,
			this.city,
			this.state,
			this.zip,
			this.country,
			].filter(item => !!item).join(", ")
	}
}
